<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Tu33ja/tc-custom/9781781314784.jpg?1738757295697" alt="This image is the cover for the book Secret Life of Fighter Command"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Secret Life of Fighter Command
      </h1>
      <p class="bookDescription body article font2">
        <b>“Bring[s] alive the all-engulfing drama of 1940, as Hitler’s Luftwaffe attempted to establish air superiority over England. . . . Poetry and sharp politics.” —<i>The Times</i></b><br/><br/>During the dark days of 1940, when Britain faced the might of Hitler’s armed forces alone, the RAF played an integral role in winning the Battle of Britain against the Luftwaffe, thus ensuring the country’s safety from invasion. The men and women of Fighter Command worked tirelessly in air bases scattered throughout the length and breadth of Britain to thwart the Nazi attacks;<i>The Secret Life of Fighter Command</i> tells their story.<br/><br/>From setting up the ground-breaking radar systems along the coast of the Southeast of England, to the distribution of spotters of bombing waves coming along the Thames Estuary, the boffins who designed and built the guidance and detection structures to organize a winning defense umbrella, to the Wrens who plotted enemy movements and then conveyed this to the various RAF squadrons stationed in the UK’s zonal defense system—all of them played a part in maintaining the security over Britain. Through exclusive interviews with various members of this unique and world famous organization, bestselling author Sinclair McKay tells the human story of how Britain survived the Nazi onslaught and enabled our Hurricanes and Spitfires to triumph over the German air force.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sinclair McKay
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Aurum Press Ltd
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ae2b760a